// extracted by mini-css-extract-plugin
export default {"container":"not-allowed_container__JaCSs","content":"not-allowed_content__pJ6vW","title":"not-allowed_title__YFY2X"};